(function (window, document, $, undefined) {
    'use strict';
    var extremeInit = {
        i: function (e) {
            extremeInit.s();
            extremeInit.methods();
        },

        s: function (e) {
            this._window = $(window),
                this._document = $(document),
                this._body = $('body'),
                this._html = $('html'),
                this._subscribePopUp = $('.subscribe-popup')
        },
        methods: function (e) {
            extremeInit.w();
            extremeInit.extremeHover();
            extremeInit.extremeBackToTop();
            extremeInit.extremeSlickActivation();
            extremeInit.popupGallery();
            //extremeInit.loadSubscribePopup();
            extremeInit.megamenuHover();
            extremeInit.mobileMenuShow();
            extremeInit.mobileMenuHide();
            extremeInit.mobileMenuNavShow();
            extremeInit.cursorAnimate();
            //extremeInit.contactForm();
            extremeInit.mobileSearch();
            //extremeInit._clickDoc();
        },

        w: function (e) {
            this._window.on('load', extremeInit.l).on('scroll', extremeInit.scrl).on('resize', extremeInit.res)
        },

        scrl: function () {

        },

        popupGallery: function () {
            $('.popup-gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Učitavanje #%curr%...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1]
                },
                image: {
                    tError: '<a href="%url%">Sliku #%curr%</a> nije moguce ucitati.',
                }
            });
        },

        mobileSearch: function () {
            $('.search-button-toggle').on('click', function (e) {
                e.preventDefault();
               $(this).toggleClass('open');
               $(this).siblings('.header-search-form').toggleClass('open');
            });
        },

        cursorAnimate: function () {
            var myCursor = jQuery('.mouse-cursor');
            if (myCursor.length) {
                if ($('body')) {
                    const e = document.querySelector('.cursor-inner'),
                        t = document.querySelector('.cursor-outer');
                    let n, i = 0,
                        o = !1;
                    window.onmousemove = function (s) {
                        o || (t.style.transform = "translate(" + s.clientX + "px, " + s.clientY + "px)"), e.style.transform = "translate(" + s.clientX + "px, " + s.clientY + "px)", n = s.clientY, i = s.clientX
                    }, $('body').on("mouseenter", "a, .cursor-pointer", function () {
                        e.classList.add('cursor-hover'), t.classList.add('cursor-hover')
                    }), $('body').on("mouseleave", "a, .cursor-pointer", function () {
                        $(this).is("a") && $(this).closest(".cursor-pointer").length || (e.classList.remove('cursor-hover'), t.classList.remove('cursor-hover'))
                    }), e.style.visibility = "visible", t.style.visibility = "visible"
                }
            }
        },


        loadSubscribePopup: function () {
            setTimeout(function () {
                extremeInit._subscribePopUp.addClass('show-popup');
            }, 3000);
        },

        mobileMenuShow: function () {
            $('.hamburger-menu').on('click', function (e) {
                e.preventDefault();
                extremeInit._body.addClass('popup-mobile-menu-show'),
                    extremeInit._html.css({
                        overflow: 'hidden'
                    });
            });
        },

        mobileMenuHide: function () {
            $('.mobile-close').on('click', function (e) {
                e.preventDefault();
                extremeInit._body.removeClass('popup-mobile-menu-show'),
                    extremeInit._html.css({
                        overflow: ''
                    });
                $('.popup-mobilemenu-area .menu-item-has-children a').removeClass('open').siblings('.extreme-submenu').slideUp('400');   

            })
            $('.popup-mobilemenu-area').on('click', function (e) {
                e.target === this && extremeInit._body.removeClass('popup-mobile-menu-show'),
                    extremeInit._html.css({
                        overflow: ''
                    });
            })
        },

        mobileMenuNavShow: function (e) {

            $('.popup-mobilemenu-area .menu-item-has-children a').on('click', function (e) {
                $(this).siblings('.extreme-submenu').slideToggle('400');
                $(this).toggleClass('open').siblings('.extreme-submenu').toggleClass('active');

                $(this).parent('.menu-item-has-children').siblings('.menu-item-has-children').children('.extreme-submenu').slideUp('400');
                $(this).parent('.menu-item-has-children').siblings('.menu-item-has-children').children('.extreme-submenu').removeClass('active');
                $(this).parent('.menu-item-has-children').siblings('.menu-item-has-children').children('a').removeClass('open');
            })

        },

        extremeHover: function () {
            $('.content-direction-column, .post-listview-visible-color').mouseenter(function () {
                var self = this;
                $(self).removeClass('extreme-control');
                setTimeout(function () {
                    $('.content-direction-column.is-active, .post-listview-visible-color .post-list-view.is-active').removeClass('is-active').addClass('extreme-control');
                    $(self).removeClass('extreme-control').addClass('is-active');
                }, 0);
            });
        },

        /*trendPost: function () {
            $(window).resize(function () {

            });
            //do something
            var width = extremeInit._window.width();
            if (width > 991) {
                $('.trend-post').mouseenter(function () {
                    var self = this;
                    $(self).removeClass('extreme-control');
                    setTimeout(function () {
                        $('.trend-post.is-active').removeClass('is-active').addClass('extreme-control');
                        $(self).removeClass('extreme-control').addClass('is-active');
                    }, 0);

                });
            }
        },*/

        megamenuHover: function () {
            $('.vertical-nav-menu li.vertical-nav-item').hover(function () {
                $('.extreme-vertical-inner').hide();
                $('.vertical-nav-menu li.vertical-nav-item').removeClass('active');
                $(this).addClass('active');
                var selected_tab = $(this).find('a').attr("data-href");
                $(selected_tab).stop().fadeIn();
                return false;
            });
        },

        extremeBackToTop: function () {
            var btn = $('#backto-top');
            $(window).scroll(function () {
                if ($(window).scrollTop() > 300) {
                    btn.addClass('show');
                } else {
                    btn.removeClass('show');
                }
            });
            btn.on('click', function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: 0
                }, '300');
            });
        },

        
        extremeSlickActivation: function (e) {
 /*           $('.slider-activation').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                fade: true,
                adaptiveHeight: true,
                cssEase: 'linear',
                prevArrow: '<button class="slide-arrow prev-arrow"><i class="fal fa-arrow-left"></i></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><i class="fal fa-arrow-right"></i></button>'
            });

            $('.modern-post-activation').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                prevArrow: '<button class="slide-arrow prev-arrow"><i class="fal fa-arrow-left"></i></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><i class="fal fa-arrow-right"></i></button>',
                responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

            // Bootstrap Tab With Slick 
            $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
                $('.modern-post-activation').slick('setPosition');
            });

            $('.post-gallery-activation').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                fade: true,
                adaptiveHeight: true,
                cssEase: 'linear',
                prevArrow: '<button class="slide-arrow prev-arrow"><i class="fal fa-arrow-left"></i></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><i class="fal fa-arrow-right"></i></button>',
            });
*/
            $('.categories-activation').slick({
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                prevArrow: '<button aria-label="prev slide" class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-icon svg-inline--fa" role="img" aria-hidden="true"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg></button>',
                nextArrow: '<button aria-label="next slide" class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-icon svg-inline--fa" role="img" aria-hidden="true"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></button>',
                responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                        }
                    }

                ]
            });
/*
            $('.slick-nav-avtivation-new').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: true,
                asNavFor: '.slick-for-avtivation-new',
                dots: false,
                focusOnSelect: true,
                verticalSwiping: false,
                centerMode: false,
                centerPadding: '0',
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: false,
                responsive: [{
                        breakpoint: 1199,
                        settings: {
                            vertical: true,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            vertical: true,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 577,
                        settings: {
                            vertical: true,
                            slidesToShow: 2,
                        }
                    }
                ]

            });

            $('.slick-for-avtivation-new').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.slick-nav-avtivation-new',
                infinite: false,
                autoplay: true,
                responsive: [{
                    breakpoint: 769,
                }]
            });*/
        },
        
        /*_clickDoc: function (e) {
            var subscribePopupHide;
            subscribePopupHide = function (e) {
                if (!$('.subscribe-popup-inner, .subscribe-popup-inner *:not(.close-popup, .close-popup i, .newsletter-content .close-button)').is(e.target)) {
                    extremeInit._subscribePopUp.fadeOut("300");
                }
            };
            extremeInit._document
                .on('click', '.close-popup', subscribePopupHide)
                .on('click', subscribePopupHide)
        }*/
    }
    extremeInit.i();

})(window, document, jQuery);